import styled from "styled-components";

const TooltipWrap = styled.div`
  position: relative;
  display: block;

  .check {
    text-align: left;
    display: inline-block;
    width: 60px;
  }

  .check * {
    vertical-align: middle;
  }

  input[type="checkbox"] + label,
  input[type="radio"] + label {
    padding: 0 0 0 22px;
    line-height: 17px;
    font-size: 13px;
    width: 100%;
    box-sizing: border-box;
  }
`;

const TooltipText = styled.div`
  position: absolute;
  background-color: rgba(255, 255, 255, 0.9);
  border: 1px solid #002c5f;
  width: auto;
  padding: 7px 5px;
  z-index: 10;
  top: -25px;
  left: 0;
  font-weight: bold;
  color: #002c5f;
  text-align: center;
  display: ${(props) => (props.show ? "inline-block" : "none")};

  &:before,
  &:after {
    content: "";
    border: solid transparent;
    height: 0;
    width: 0;
    position: absolute;
    z-index: 20;
    bottom: -12px;
    left: 50%;
    transform: translateX(-50%);
  }

  &:before {
    border-top-color: #002c5f;
    border-width: 6px;
    margin-top: 5px;
  }

  &:after {
    border-top-color: #fff;
    border-width: 7px;
  }
`;

const TooltipWrapper = ({ children, show, message }) => {
  return (
    <TooltipWrap>
      {children}
      <TooltipText show={show}>{message}</TooltipText>
    </TooltipWrap>
  );
};

export default TooltipWrapper;
